const ALLOWED_FILTERS = new Set([
  'search', 'clinics', 'limit', 'logType', 'mealType', 'nutrition', 'glucose',
]);
const ALLOWED_TABS = new Set([
  'summary', 'logs', 'logs-v2', 'nutrients', 'prescriptions', 'recipes', 'meal-plans',
  'emotions', 'reports', 'resources', 'subscriptions',
]);
const ALLOWED_VARIANTS = new Set([
  'recipes', 'meal-plan', 'food-substitutions',
]);
const ALLOWED_GOAL_TYPES = new Set(['nutrient', 'frequency']);
const ALLOWED_REPORT_SECTIONS = new Set([
  'Clinician Generated', 'RxFood Generated', 'Sent',
]);

/** Send only known, bounded analytics properties to the browser SDK. */
export function sanitizeSegmentation(
  properties: Record<string, unknown>,
): Record<string, string | number | boolean> {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(properties)) {
    if (key === 'filter' && typeof value === 'string' && ALLOWED_FILTERS.has(value)) {
      result[key] = value;
    } else if (key === 'tab' && typeof value === 'string' && ALLOWED_TABS.has(value)) {
      result[key] = value;
    } else if (key === 'variant' && typeof value === 'string' && ALLOWED_VARIANTS.has(value)) {
      result[key] = value;
    } else if (key === 'Report Section' && typeof value === 'string' && ALLOWED_REPORT_SECTIONS.has(value)) {
      result[key] = value;
    } else if (key === 'tip_length' && typeof value === 'number' && Number.isFinite(value)) {
      result[key] = Math.max(0, Math.min(300, Math.floor(value)));
    } else if (key === 'goal_type' && typeof value === 'string' && ALLOWED_GOAL_TYPES.has(value)) {
      result[key] = value;
    }
  }
  return result;
}

/** Remove patient IDs from analytics view paths, including opaque IDs. */
export function parameterizePath(pathname: string): string {
  return pathname
    .replace(/(^|\/)patient\/[^/]+/g, '$1patient/:id')
    .replace(/(^|\/)patients\/reports\/cgm\/[^/]+/g, '$1patients/reports/cgm/:id')
    .replace(/\/\d+/g, '/:id')
    .replace(/\/logV2(?=\/|$)/g, '/logv2')
    .replace(/\/+$/, '') || '/';
}
